import styled from 'styled-components';

export const RecentItemsCarouselContainer = styled.div``;
